import { Currency } from '@synergy/models';

export const currencyReducer = (state = Currency.EUR) => {
    return state;
};
